import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  testimonialData: [],
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const fetchTestimonial = createAsyncThunk(
  "testimonial/data",
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        "https://nutirents.developer-ourbase-camp.com/api/v1/testimonial"
      );
      return data.response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const testimonialSlice = createSlice({
  name: "testimonial",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimonial.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTestimonial.fulfilled, (state, action) => {
        state.isLoading = false;
        state.testimonialData = action.payload;
        state.isSuccess = true;
      })
      .addCase(fetchTestimonial.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload;
        state.isSuccess = false;
      });
  },
});

export default testimonialSlice.reducer;
